'use client'

import Layout from '../components/layout'
import { ForgotPassword as ForgotForm } from "@atomicleads/ext-satellite-form";

function ForgotPage() {
    return (
        <div className="forgot">
            <ForgotForm />
        </div>
    )
}

export default ForgotPage;
